import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import { EPR_ARCHIVE_GRADING_PROFILES, EPR_DOWNLOAD, EPR_TIMEPERIODS_BY_SCHOOL_YEAR } from "../const/EprConst";

/**
 * Data Access for the EPR API
 * @name EprDao
 * @param {*} props
 */
const EprDao = (props) => {
    const { action, gradingProfileId, schoolYearKey, studentNumber, token } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        },
        withCredentials: true
    };
    switch (action) {
        case "archiveGradingProfilesRead":
            options.method = "GET";
            options.url = `${EPR_ARCHIVE_GRADING_PROFILES}/${studentNumber}/${schoolYearKey}/index.json`;
            break;
        case "eprPdfDownload":
            options.responseType = "blob";
            options.headers.Accept = "application/pdf";
            options.method = "GET";
            options.url = `${EPR_DOWNLOAD}/${studentNumber}/${gradingProfileId}/detail.json`;
            break;
        case "timePeriodsBySchoolYearRead":
            options.method = "GET";
            options.url = `${EPR_TIMEPERIODS_BY_SCHOOL_YEAR}/${schoolYearKey}/index.json`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

EprDao.propTypes = {
    action: PropTypes.string.isRequired,
    gradingProfileId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    schoolYearKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    studentNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    token: PropTypes.string.isRequired
};

EprDao.defaultProps = {
    gradingProfileId: null,
    schoolYearKey: null,
    studentNumber: null
};

export default EprDao;
